import { Environment } from '../types';

export const environment: Environment = {
  production: true,
  config: {
    environment: 'prod',
    account: '__ACCOUNT',
    idLivestreaming: '__IDLIVESTREAMING',
    originOfProducts: '_ORIGINOFPRODUCTS',
    isInGlobalPage: '_ISINGLOBALPAGE',
    isInfinite: '_ISINFINITE',
    redirectTo: '_PDP',
    showChat: '_INACTIVATECHAT',
    showLike: '_INACTIVATELIKE',
    showQuickView: '_SHOWQUICKVIEW',
    showProductsCarousel: '_INACTIVEPRODUCTSCAROUSEL',
    showSidebarProducts: '_INACTIVESIDEBARPRODUCTS',
    showViewers: '_INACTIVATEVIEWERS',
    time: '_TIME',
  } as any,
};

export default environment;
